import { formatMoney } from 'accounting'

import {
  Button, Form, SidebarModal,
} from '@domain-group/suit-theme'

import useGenerateCampaignSchedule from '@hooks/useGenerateCampaignSchedule'

import type { CampaignModel } from '@domain-group/realhub-backend-api-types'

const MODAL_KEY = 'GenerateCampaignScheduleModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  campaign: CampaignModel,
  showModal: boolean,
}

const GenerateCampaignScheduleModal = (props: ModalProps) => {
  const { callbacks, campaign, showModal } = props

  const generateCampaignSchedulePayload = useGenerateCampaignSchedule({ campaign })
  const {
    callbacks: {
      downloadSchedule,
      selectEntityId,
    },
    filteredCampaignItems,
    filteredCampaignQuotes,
    groupedOrders: {
      visible: visibleOrders,
    },
    hasSelectedItems,
    state: {
      selectedCampaignItemIds,
      selectedOrderIds,
      selectedPendingQuoteIds,
    },
  } = generateCampaignSchedulePayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Generate" titleSecondLine="Campaign Schedule" />

      <SidebarModal.Content>
        <Form>
          {!!visibleOrders.length && (
            <Form.Field label="Orders">
              {visibleOrders.map((order) => {
                // @ts-expect-error TS2339
                const selected = selectedOrderIds.includes(order.id)

                return (
                  <SidebarModal.SelectItem
                    callbacks={{
                      // @ts-expect-error TS2339
                      selectItem: () => selectEntityId('selectedOrderIds', order.id),
                    }}
                    // @ts-expect-error TS2339
                    key={order.id}
                    // @ts-expect-error TS2339
                    title={order.title}
                    selected={selected}
                    // @ts-expect-error TS2339
                    subtitle={formatMoney(order.total)}
                  />
                )
              })}
            </Form.Field>
          )}

          {!!filteredCampaignItems.length && (
            <Form.Field label="Campaign Items" marginTop="large">
              {filteredCampaignItems.map((campaignItem) => {
                const selected = selectedCampaignItemIds.includes(campaignItem.id)

                return (
                  <SidebarModal.SelectItem
                    callbacks={{
                      selectItem: () => selectEntityId('selectedCampaignItemIds', campaignItem.id),
                    }}
                    key={campaignItem.id}
                    // @ts-expect-error TS2322
                    title={campaignItem.title}
                    selected={selected}
                    // @ts-expect-error TS2769
                    subtitle={formatMoney(campaignItem.price_override)}
                  />
                )
              })}
            </Form.Field>
          )}

          {!!filteredCampaignQuotes.length && (
            <Form.Field label="Pending Quotes" marginTop="large">
              {filteredCampaignQuotes.map((campaignQuote) => {
                const selected = selectedPendingQuoteIds.includes(campaignQuote.id)

                return (
                  <SidebarModal.SelectItem
                    callbacks={{
                      selectItem: () => selectEntityId('selectedPendingQuoteIds', campaignQuote.id),
                    }}
                    key={campaignQuote.id}
                    title={campaignQuote.title}
                    selected={selected}
                    // @ts-expect-error TS2339
                    subtitle={formatMoney(campaignQuote.total)}
                  />
                )
              })}
            </Form.Field>
          )}
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!hasSelectedItems}
          onClick={downloadSchedule}
          size="large"
        >
          Download Schedule
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <GenerateCampaignScheduleModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
